import { Markdown, Mention, Plugin } from 'ckeditor5';
export class CustomMentionsEditing extends Plugin {
    static get pluginName() {
        return 'CustomMentionsEditing';
    }
    static get requires() {
        return [Mention, Markdown];
    }
    init() {
        const { editor } = this;
        const mentionPlugin = editor.plugins.get('Mention');
        // Markdown Link -> Model
        editor.conversion.for('upcast').elementToAttribute({
            view: {
                name: 'a',
                attributes: {
                    // By converting to and from a anchor field, the markdown plugin just works
                    href: /^(user|team):/,
                },
            },
            model: {
                key: 'mention',
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                value: (viewItem) => {
                    const href = decodeURIComponent(viewItem.getAttribute('href'));
                    const [type, id] = href.split(':'); // Split "user:auth0|123"
                    // Reconstruct the unique ID to match the Feed format: "@user:auth0|123"
                    // The marker ('@') is required by CKEditor's internal logic.
                    const uniqueId = `@${type}:${id}`;
                    // Convert to a native mention attribute, with some extra attributes we can use when outputting to markdown
                    return mentionPlugin.toMentionAttribute(viewItem, {
                        link: href,
                        userId: id,
                        id: uniqueId, // Uniqueness guaranteed
                    });
                },
            },
            converterPriority: 'high',
        });
        // Model -> View/Output
        editor.conversion.for('downcast').attributeToElement({
            model: 'mention',
            view: (mention, { writer }) => {
                if (!mention) {
                    return undefined;
                }
                const [type, id] = mention.link.split(':'); // => ['user', 'auth0|123']
                // By converting to and from a anchor field, the markdown plugin just works
                return writer.createAttributeElement('a', {
                    class: 'custom-mention-pill',
                    href: `${type}:${id}`,
                }, {
                    priority: 20,
                    id: mention.id,
                });
            },
            converterPriority: 'high',
        });
    }
}
